const API_BASE_URL = window.__APP_CONFIG__?.API_URL || 'http://localhost/task/backend/routes/api.php';

class ClientConfigService {
  constructor() {
    this.config = null;
    this.listeners = [];
  }

  async fetchConfig() {
    try {
      // Fetch COMPARTIDO con appConfig (window.__PUBLIC_CONFIG_FETCH__): una
      // única petición get_public_config por carga de la app.
      if (!window.__PUBLIC_CONFIG_FETCH__) {
        window.__PUBLIC_CONFIG_FETCH__ = fetch(`${API_BASE_URL}?endpoint=get_public_config`)
          .then((r) => r.json())
          .catch((err) => {
            delete window.__PUBLIC_CONFIG_FETCH__;
            throw err;
          });
      }
      const result = await window.__PUBLIC_CONFIG_FETCH__;
      
      if (result.status === 'success' && result.data) {
        this.config = result.data;
        this.notifyListeners();
        return this.config;
      }
      
      return this.getDefaultConfig();
    } catch (error) {
      console.error('Error loading client config:', error);
      return this.getDefaultConfig();
    }
  }

  getDefaultConfig() {
    return {
      nombre_empresa: 'ITOS',
      logo_url: null,
      // Default = crawl y gads activos (igual que el backend pre-migración):
      // evita que las guardas de ruta bloqueen crawl/gads antes de cargar.
      // changelog es opt-in (backend default false): NO va en el fallback.
      addons: { crawl: true, gads: true },
      // Orden por defecto de las pestañas.
      addons_order: ['crawl', 'gads', 'changelog']
    };
  }

  getConfig() {
    return this.config || this.getDefaultConfig();
  }

  // true cuando la config real del tenant ya ha llegado (getConfig() devuelve
  // el valor por defecto mientras tanto). Lo usan las guardas de ruta para no
  // redirigir antes de saber qué addons tiene el cliente.
  isLoaded() {
    return this.config !== null;
  }

  subscribe(listener) {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter(l => l !== listener);
    };
  }

  notifyListeners() {
    this.listeners.forEach(listener => listener(this.config));
  }
}

const clientConfigService = new ClientConfigService();
export default clientConfigService;